import React from 'react';

export const CrossImage = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5 5L12 12M12 12L19 19M12 12L19 5M12 12L5 19" stroke="#9D9D9D" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};
